module.exports = __webpack_public_path__ + "media/goforajourney/img/drawing-8bf640a0bc90fa757c60f0a7d68fc103.jpg";